import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Site } from './screens.types';

@Component({
  selector: 'app-mode-degrade-screen',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './mode-degrade-screen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./mode-degrade-screen.component.scss'],
})
export class ModeDegradeScreenComponent {
  @Input({ required: true }) site!: Site;

  @Output() activated = new EventEmitter<void>();

  activate() {
    this.activated.emit();
  }

  tensionKey(): string {
    return { critique: 'critique', moderee: 'tension', fluide: 'fluide', ferme: 'fluide' }[this.site.statut];
  }

  tensionEmoji(): string {
    return { critique: '🔴', moderee: '🟠', fluide: '🟢', ferme: '⚫' }[this.site.statut];
  }

  tensionType(): string {
    return { critique: 'Tension critique', moderee: 'Tension accueil', fluide: 'Flux fluide', ferme: 'Site fermé' }[this.site.statut];
  }

  tensionNiveau(): string {
    return {
      critique: 'Rouge — Dégradation critique du flux',
      moderee:  'Orange — Dégradation progressive du flux',
      fluide:   'Vert — Situation normale',
      ferme:    'Site fermé',
    }[this.site.statut];
  }

  tensionMinutes(): number | null {
    const tl = this.site.timeline;
    const firstIdx = tl.findIndex(c => c !== 'vert');
    return firstIdx !== -1 ? (5 - firstIdx) * 15 : null;
  }
}